import { FilterOperator, Role } from 'generated/graphql';
import { AutocompleteInput, ReferenceInput } from 'react-admin';

interface Props {
  source: string;
  disabled?: boolean;
  label?: string;
  roles?: Role[];
}

const filterToQuery = (searchText: string) => ({
  filterCondition1: {
    fieldPath: 'email',
    operator: FilterOperator.Ilike,
    values: [`%${searchText}%`],
  },
});

export const UserInput: React.FC<Props> = ({
  disabled,
  label,
  roles = [Role.RoleAdmin, Role.RoleClient, Role.RoleFinancialAdvisor, Role.RoleScout],
  source,
}) => {
  return (
    <ReferenceInput
      // default filter for all queries
      filter={{
        filterCondition: {
          fieldPath: 'roles.role',
          operator: FilterOperator.In,
          values: roles,
        },
      }}
      reference="User"
      required
      source={source}
    >
      <AutocompleteInput
        disabled={disabled}
        filterToQuery={filterToQuery}
        label={label}
        optionText="email"
        sx={{ width: '40em' }}
      />
    </ReferenceInput>
  );
};
